export const searchTaxonomyByKey = (taxonomy, key) => {
  const tipo = taxonomy.filter(item => item.value === key);
  if (tipo.length > 0) {
    return tipo[0];
  }
  return null;
};

export const searchTaxonomyByValue = (taxonomy, value) => {
  const tipo = taxonomy.filter(item => item.text === value);
  if (tipo.length > 0) {
    return tipo[0];
  }
  return null;
};




// WEBPACK FOOTER //
// ./src/utils.js